import React, {memo} from 'react';
import styles from './styles.module.scss';
import {ThirtyText} from "@/app/components/texts";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import DatePicker from "@/app/components/date_picker";

interface Props {
  onChange?: (value: Date) => void;
  initialDate?: Date;
}

const SelectDayAndMonth: React.FC<Props> = ({onChange, initialDate}) => {


  return <div className={styles.selectDayAndMonth}>
    <ThirtyText text={t(s.selectDayAndMonth)}/>
    <DatePicker
      initialDate={initialDate}
      onChange={onChange}
      className={styles.datePicker}
      onlyDayAndMonth
      isReverse
      disablePast
    />
  </div>;
};

export default memo(SelectDayAndMonth);
